import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import { getInputField } from '../subscriptor/forms/fields';
import { maintainerForm as styles } from '../maintainer/styles';
import { WARRANTY_MAX_LENGTH_CODE, WARRANTY_MAX_LENGTH_NAME } from '../../libraries/constants';
import { maximumSubString } from '../../libraries/utils';

const WarrantyForm = props => {
  const { values, classes, handleBlur, errors, touched, setFieldValue, title } = props;

  const fieldProps = {
    handleBlur,
    classes,
    touched,
    errors,
    values,
    setFieldValue
  };

  return (
    <Card className={classes.card}>
      <CardHeader title={title} className={classes.cardTitle} />
      <CardContent className={classes.cardContent}>
        {values ? (
          <React.Fragment>
            {getInputField({
              ...fieldProps,
              name: `code`,
              label: `Código`,
              required: true,
              changeHandler: maximumSubString(WARRANTY_MAX_LENGTH_CODE),
              formControlClass: classes.fullWidth
            })}

            {getInputField({
              ...fieldProps,
              name: `name`,
              label: 'Nombre',
              required: true,
              changeHandler: maximumSubString(WARRANTY_MAX_LENGTH_NAME),
              formControlClass: classes.fullWidth
            })}
          </React.Fragment>
        ) : (
          ''
        )}
      </CardContent>
    </Card>
  );
};

WarrantyForm.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(WarrantyForm);
